import { render, staticRenderFns } from "./CopyPanel.vue?vue&type=template&id=33de793c&scoped=true"
import script from "./CopyPanel.vue?vue&type=script&lang=js"
export * from "./CopyPanel.vue?vue&type=script&lang=js"
import style0 from "./CopyPanel.vue?vue&type=style&index=0&id=33de793c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de793c",
  null
  
)

export default component.exports